import firebase from 'firebase';
firebase.initializeApp({
                            apiKey:            "AIzaSyDhYALsDhceEiQcuiXvAa-zsbyq3zi1AKM",
                            authDomain:        "landing-form-colector.firebaseapp.com",
                            databaseURL:       "https://landing-form-colector.firebaseio.com",
                            projectId:         "landing-form-colector",
                            storageBucket:     "landing-form-colector.appspot.com",
                            messagingSenderId: "134724194864",
                            appId:             "1:134724194864:web:bcd2eeb0c8c38acdd293f5",
                            measurementId: "G-KQJK5V51VG"
                        });
export default firebase;